export const enggDataSources = [
  {
    title: 'Engineering, Production, Quality, Material',
    content:
      'The current version of TrafoChat is trained using a limited selection of Hitachi Energy’s technical standards: TrafoStar (PT), SPT Mainstream (PT), StarLiquid (DT), and StarDry (DT). This subset of documents will be expanded in future iterations of the tool.',
    sourceSystem: null,
    prompts: [
      'For a Seismic design, base enhancement, how many gussets shall be welded?',
      'In the case of 34kV & 170BIL and conductor thickness of 0.005 inch, which type of inner insulation should be applied?',
      'What is the recommended LV coil height for a 1170mm HV electrical height with 30mm end fill and BIL 170kV in IEC?'
    ],
    datasourcelink: ''
  }
]
